import { Select as BaseSelect } from 'antd'
import styled from 'styled-components'

export const Select = styled(BaseSelect)`
  max-width: 198px;
  width: 100%;
`
